module.exports = __webpack_public_path__ + "img/3.125d7d45.webp";